module.exports = __webpack_public_path__ + "img/astigmatism.9881241d.png";